import React from 'react';

import TextBox from '../../ui/TextBox';
import DateTime from '../../ui/DateTime';

import CheckBox from '../../ui/CheckBox';

function BlStatusRowImpl({
  label,
  disabled,
  checked,
  onToggle,
  dateTime = null,
  onDateTimeChange = () => {},
  userId = '',
  onTabNext,
  noStatus = false,
  labelColor = '',
  name=undefined,
  showDatePlaceHolder = true,
}: {
  label: string,
  disabled: boolean,
  checked: boolean,
  onToggle: (checked: boolean) => void,
  dateTime?: string | null,
  onDateTimeChange?: (dt: string|null) => void,
  userId?: string,
  onTabNext?: (() => boolean) | undefined,
  noStatus?: boolean,
  name?: string|undefined,
  labelColor?:string,
  showDatePlaceHolder?: boolean
}) {
  function onCheckTabNext(): boolean {
    if (checked || !onTabNext) {
      // If it is checked, date/time component is enabled so let the default tab flow handle it
      return false;
    }

    onTabNext();
    return true;
  }

  function renderStatus() {
    if (noStatus) {
      return null;
    }

    return (
      <>
        <div style={{width: '130px'}}><DateTime disabled={disabled || !checked} value={dateTime} onChange={onDateTimeChange} onTimeTabNext={onTabNext} name={name} showPlaceHolder={showDatePlaceHolder}/></div>
        <div style={{width: '50px'}}><TextBox disabled noLeftBorder value={userId} name={`${name}-text`} /></div>
      </>
    );
  }

  // with internal padding between check mark and label (9px) => 21 + 9 = 30px
  const renderedCheckbox = <CheckBox labelColor={labelColor} name={`${name}-check`} style={{width: '21px'}} label={label} disabled={disabled} value={checked} onChange={onToggle} onTabNext={onCheckTabNext} />
  // const renderedCheckbox = <CheckBox label={label} disabled={disabled} value={checked} onChange={onToggle} onTabNext={onCheckTabNext} />

  return (
    <div style={{display: 'flex'}}>
      <div style={{width: '145px'}}>
        {renderedCheckbox}
      </div>
      <div style={{width: '180px', display: 'flex'}}>
        {renderStatus()}
      </div>
    </div>
  );
}

const BlStatusRow = React.memo(BlStatusRowImpl);

export default BlStatusRow;
